{
	"backToManageDeclarations": "Terug naar Verklaringen beheren"
}
